import { IQuestion, IQuestionResponse, TreeItemType } from "@aa/common";

export class TreeQuestionResponse implements IQuestionResponse {
  nextId?: Guid;
  nextType: TreeItemType;
  text: string;
  href?: string;

  inline?: boolean;
  inlineResponseText: string | null = null;

  responseHref: string | null = null;
  hidden = false;

  constructor(q: IQuestionResponse) {
    this.nextType = q.nextType;
    this.nextId = q.nextId;
    this.text = q.text;
    this.href = q.href;
  }
}

export class TreeQuestion implements IQuestion {
  public selectedIndex = -1;
  public selectedResponse: IQuestionResponse | null = null;

  public id: Guid;
  public readonly slug?: string;
  public readonly text?: string;
  public readonly name?: string;
  public readonly info?: string;
  public readonly relatedQuestionId?: Guid;
  public readonly responses: TreeQuestionResponse[];

  questionHref: string | null = null;

  noHighlight = false;
  showInfo: boolean;

  constructor(q: IQuestion) {
    if (!q.id) {
      throw new Error("Question must have an id");
    }
    this.id = q.id;
    this.slug = q.slug;
    this.text = q.text;
    this.name = q.name;
    this.info = q.info;
    this.relatedQuestionId = q.relatedQuestionId;
    this.responses = q.responses.map((o) => new TreeQuestionResponse(o));
    this.setSelectedIndex(-1);

    // hide info if response list contains a "More Info" button
    this.showInfo =
      Boolean(this.info) &&
      !this.responses.some((o) => o.nextType === TreeItemType.MoreInfo);
  }

  get hasSelectedIndex(): boolean {
    return this.selectedIndex >= 0;
  }

  isValidIndex(index: number): boolean {
    return index >= 0 && index < this.responses.length;
  }

  setSelectedIndex(index: number): boolean {
    if (!this.isValidIndex(index)) {
      this.selectedIndex = -1;
      this.selectedResponse = null;
      return false;
    }

    this.selectedIndex = index;
    this.selectedResponse = this.responses[index];
    return true;
  }

  public clearSelectedIndex() {
    this.setSelectedIndex(-1);
  }
}
